operations:
  load-models: Charger Modèle
  load-models-status:
    loading: Chargement
    ready: Prêt
docs:
  theme:
    navbar:
      appearance:
        title: Apparence
'controls-island':
  'fade-on-hover':
    enable: Masquer au survol
    disable: Toujours afficher
  'open-settings': Ouvrir les paramètres
  'open-chat': Ouvrir le Chat
  'refresh': Actualiser
  'center-main-window': Move to screen center
  'open-hearing-controls': Ouvrir les contrôles d'écoute
  'drag-to-move-window': Glisser pour déplacer la fenêtre
  'stop-speaking': Arrêter la parole
  'speaker-idle': Haut-parleur
  'switch-to-light-mode': Passer au mode clair
  'switch-to-dark-mode': Passer au mode sombre
  'pin-on-top': Épingler en haut
  'unpin-from-top': Désépingler du haut
  'switch-profile': Changer de Profil
  'close': Fermer
  'expand': Développer
  'collapse': Réduire
  'login': Se connecter
  'logging-in': Connexion en cours...
  'account': Compte
  'logout': Compte
widgets:
  close: Fermer le widget
  empty:
    title: Pas de widget actif
    description: Les widgets apparaîtront ici lorsqu'un outil ou un plugin en génèrera un.
  loading: Chargement du widget…
  waiting: En attente des données du widget pour "{id}"…
notice:
  'fade-on-hover':
    title: Disparaître au survol
    intro: Fait disparaître légèrement le personnage quand le curseur s’approche. Moins de distractions tout en restant visible.
    opacity: Une fois activé, l’opacité descend à {value} pour {targets} quand le curseur est à proximité.
    toggle: Vous pouvez le désactiver en survolant l’{controls}, puis en cliquant à nouveau sur l’{icon}.
    controls-label: Îlot de commandes
    icon-label: icône œil barré
    value: '0'
    targets: Personnage et UI
    confirm: Compris
    dont-show-again: Ne plus afficher
    preparing: Préparation…
    read-more: En savoir plus
    preview-title: C’est quoi ?
about:
  subtitle: Version de bureau.
  current-version: Version actuelle
  common:
    cancel: Annuler
  links:
    title: Liens
    home: Accueil
    documentation: Documentation
    github: GitHub
  update:
    lane:
      label: Canal de mise à jour
      description: Choisissez le canal de mise à jour à utiliser
      placeholder: Sélectionnez un canal de mise à jour
    channels:
      auto: Automatique
      stable: Stable
      alpha: Alpha
      beta: Bêta
      nightly: Nocturne
      canary: Expérimental
    status:
      downloading: Téléchargement de la mise à jour...
      error-prefix: Erreur
      latest: À jour (v.{version}).
      downloaded:
        windows: Mise à jour prête à être installée silencieusement (v{version}).
        restart: Mise à jour prête à être installée au redémarrage (v{version}).
    actions:
      download: Télécharger la mise à jour
      download-short: Télécharger
      confirm-download: Confirmer le téléchargement
      check-for-updates: Rechercher des mises à jour
      checking: Vérification en cours...
      latest-version: Dernière version
      disabled-dev: Mises à jour désactivées en développement
      retry-check: Réessayer la vérification
      restart-silent: Redémarrer pour mettre à jour silencieusement
      restart-install: Redémarrez pour installer la mise à jour
      confirm-restart: Confirmer le redémarrage
    dialog:
      title: Mise à jour disponible
      description: Une nouvelle version (v{version}) est disponible.
      no-release-notes-markdown: _ Aucune note de mise à jour fournie._
